import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  CHANGE_PASSWORD
} from '../constants';
import axiosInstance from '../../config/axios';
import { useHistory } from 'react-router-dom';
import AuthService from '../../services/auth.service';
import {
  setUserSession,
  removeUserSession,
  setUserMenus
} from '../../utils/UserDetails';
import { hideLoader, setCommonNotification, showLoader } from '../common/actions';
import { hideModal, setModalButtonLoading, showModal} from '../modal/actions';




export const loginUser =
  (loginInput, setSubmitting, setFieldValue, history, redirect = '') =>
  async (dispatch) => {
    try {
                dispatch(showLoader());
      const resultData = await AuthService.userLogin(loginInput);
      if (resultData.status !== undefined) {
        if (resultData.status === true) {
          let userData = resultData?.data ? resultData.data : '';
          setUserSession(userData.access_token,userData.expires_in);
  
          if (userData?.access_token && userData.access_token) {
            axiosInstance.interceptors.request.use(function (config) {
              config.headers.Authorization = `Bearer ${userData.access_token}`;
              return config;
            });

             if (userData?.usermenu?.length) {
              setUserMenus(userData?.usermenu);
             }

            if (redirect) {
              history.push(redirect);
            } else {
              history.push('/');
            }
          }
        } else {
          if (resultData.message) {
 dispatch(showModal({
                  title: "Failure",
                  message: resultData.message,
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
            setFieldValue('password', '', false);
            setSubmitting(false);
          } else {
 dispatch(showModal({
                  title: "Failure",
                  message: resultData.error,
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
            setFieldValue('password', '', false);
            setSubmitting(false);
          }
        }
      } else {
           dispatch(showModal({
                  title: "Failure",
                  message: "Please Try Again",
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
        setFieldValue('password', '', false);
        setSubmitting(false);
      }
    } catch (err) {
 dispatch(showModal({
                  title: "Failure",
                  message: "Please Try Again",
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
      setFieldValue('password', '', false);
      setSubmitting(false);
    }
            finally {
      dispatch(hideLoader());
    }
  };


export const userLogout =
  (history, redirect = '') =>
  async (dispatch) => {
    try {
      const resultData = await AuthService.userLogout();
      dispatch(hideModal());
      if (resultData?.status && resultData.status === true) {
        dispatch({ type: 'DESTROY_SESSION' });
        removeUserSession();
      }
      // window.location.href = (redirect) ? redirect : "/"
      history.push('/');
    } catch (err) {
      dispatch(setModalButtonLoading(null));
      dispatch(showModal({
        title: "Error",
        message: "Delete failed",
        iconType: "error",
      }));
      console.log(err);
    }
  };

  export const getChangePassword =
  (loginInput, setSubmitting, resetForm) => async (dispatch) => {
    try {
          dispatch(showLoader());

      const resultData = await AuthService.changePassword(loginInput);

      if (resultData?.status) {
        setSubmitting(false);
        resetForm();
        
                                         dispatch(showModal({
                  title: "Success",
                  message: "Updated successfully",
                  iconType: "success",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
                      dispatch({
        type: CHANGE_PASSWORD,
        payload: resultData,
      });
      }else{
           dispatch(showModal({
                  title: "Failure",
                  message: resultData.message,
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
      }
      setSubmitting(false);

    } catch (err) {
      console.log(err);
    }
        finally {
      dispatch(hideLoader());
    }
  };